/* Routine finder measurement. No answers or personal data are published. */
(() => {
  'use strict';
  if (window.BFBFinderAnalytics) return;
  const script = document.currentScript;
  const preview = script?.dataset.themeRole !== 'main' || window.Shopify?.designMode ||
    new URL(location.href).searchParams.has('preview_theme_id') || location.hostname.endsWith('shopifypreview.com');
  const sources = ['home', 'systems', 'product', 'direct'];
  const names = ['entry_view', 'entry_click', 'quiz_view', 'quiz_start', 'step_view', 'step_complete', 'quiz_complete', 'result_view', 'details_click', 'quiz_add_to_cart'];
  const key = 'bfb-finder-measurement-v1';
  const ttl = 30 * 60 * 1000;
  let state = { source: 'direct', seen: {}, updatedAt: Date.now() };
  try {
    const saved = JSON.parse(sessionStorage.getItem(key));
    if (saved && sources.includes(saved.source) && saved.seen && typeof saved.seen === 'object' &&
      Number.isFinite(saved.updatedAt) && Date.now() - saved.updatedAt >= 0 && Date.now() - saved.updatedAt < ttl) state = saved;
  } catch { /* Analytics must never interrupt shopping. */ }
  const requestedSource = new URL(location.href).searchParams.get('rf_source');
  if (sources.includes(requestedSource)) state.source = requestedSource;
  const readyCallbacks = [];
  const save = () => {
    if (!allowed()) return;
    state.updatedAt = Date.now();
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch { /* Optional persistence. */ }
  };
  function allowed() {
    return !preview && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  }
  function track(name, fields = {}, once = false) {
    if (!names.includes(name) || !allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return false;
    const entry = sources.includes(fields.entry_point) ? fields.entry_point : state.source;
    const data = { finder_version: '1', entry_point: entry, environment: 'production' };
    if (Number.isInteger(fields.step_number) && fields.step_number >= 1 && fields.step_number <= 4) data.step_number = fields.step_number;
    const dedupe = `${name}:${entry}:${data.step_number || ''}`;
    if (once && state.seen[dedupe]) return false;
    try {
      const sent = window.Shopify.analytics.publish(`bfb_finder:${name}`, data);
      if (sent === false) return false;
      if (once) { state.seen[dedupe] = true; save(); }
      if (sent?.catch) sent.catch(() => { delete state.seen[dedupe]; save(); });
      return true;
    } catch { return false; /* A blocked pixel must not break the finder. */ }
  }
  window.BFBFinderAnalytics = {
    track,
    restart() { state.seen = {}; save(); },
    onReady(callback) { readyCallbacks.push(callback); if (allowed()) callback(); },
  };
  function setupEntries() {
    document.querySelectorAll('[data-bfb-finder-entry]').forEach(entry => {
      const source = entry.dataset.bfbFinderEntry;
      const link = entry.querySelector('a[href*="view=routine-finder"]');
      if (!link) return;
      const url = new URL(link.href);
      url.searchParams.set('rf_source', source);
      link.href = url.href;
      link.addEventListener('click', () => {
        state.source = source;
        if (allowed()) save();
        track('entry_click', { entry_point: source });
      });
      let viewed = false;
      function impression() {
        const box = entry.getBoundingClientRect();
        if (!viewed && allowed() && box.bottom > 0 && box.top < innerHeight) {
          viewed = track('entry_view', { entry_point: source });
        }
      }
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(items => {
          if (items.some(item => item.isIntersecting && item.intersectionRatio >= .5)) impression();
        }, { threshold: .5 });
        observer.observe(entry);
      } else impression();
      readyCallbacks.push(impression);
      impression();
    });
  }
  const notifyReady = () => readyCallbacks.forEach(callback => callback());
  document.addEventListener('visitorConsentCollected', notifyReady);
  if (!preview && !window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) notifyReady(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupEntries, { once: true });
  else setupEntries();
})();
